Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PctyListDivider = require('./PctyListDivider');

var _PctyListDivider2 = _interopRequireDefault(_PctyListDivider);

var _typeValidation = require('./typeValidation');

var _typeValidation2 = _interopRequireDefault(_typeValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PctyListGroup = function PctyListGroup(_ref) {
  var active = _ref.active,
      children = _ref.children,
      colSpan = _ref.colSpan,
      index = _ref.index,
      text = _ref.text,
      onClick = _ref.onClick;

  var onClickHandler = !!onClick ? function () {
    return onClick(index);
  } : function () {};

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_PctyListDivider2.default, { text: text, colSpan: colSpan, active: active, className: 'pcty-accordion', onClick: onClickHandler }),
    active ? children : null
  );
};

PctyListGroup.propTypes = {
  active: _propTypes2.default.bool,
  /** Determines number of columns rendered in divider  */
  colSpan: _propTypes2.default.number,
  index: _propTypes2.default.number,
  /** Inserts text for divider/group  */
  text: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.node.isRequired,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation2.default)(props, propName, componentName, 'PctyListGroup');
  }
};

PctyListGroup.defaultProps = {
  active: true,
  colSpan: 1,
  __TYPE: 'PctyListGroup'
};

exports.default = PctyListGroup;